import React, { useEffect, useState } from "react";
import { Table, Space, Button, Row, Col, Input, Modal, Form, Select, DatePicker, Tag, notification, Tooltip, Pagination, } from "antd";
import { EditOutlined, SearchOutlined } from "@ant-design/icons";
import { transactionService } from "../../../../services";
import dayjs from "dayjs";
import { changeDocumentTitle } from "../../../../utils/title";

function BrowseTranscation() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [banks, setBanks] = useState([]);
  const [paymentMode, setPaymentMode] = useState([]);
  const [isModalShow, setIsModalShow] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });

  const options = [
    {
      value: "10",
      label: "10",
    },
    {
      value: "25",
      label: "25",
    },
    {
      value: "50",
      label: "50",
    },
  ];

  const columns = [
    {
      title: "Transaction Id",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Invoice Number",
      dataIndex: "invoice_id",
      key: "invoice_id",
    },
    {
      title: "Mode Of Payment",
      dataIndex: "payment_mode",
      key: "payment_mode",
    },
    {
      title: "Payment Amount",
      dataIndex: "collected_amount",
      key: "collected_amount",
    },
    {
      title: "Balance",
      dataIndex: "balance",
      key: "balance",
    },
    {
      title: "Payment Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag
          type="primary"
          size="small"
          style={{
            backgroundColor:
              status === 1
                ? "orange"
                : status === 2
                  ? "#1fd655"
                  : status === 0
                    ? "red"
                    : "transparent",
          }}
          color="white"
        >
          {status === 0
            ? "Not paid"
            : status === 1
              ? "Partial"
              : status === 2
                ? "Complete"
                : "N/A"}
        </Tag>
      ),
    },
    {
      title: "Payment Date",
      dataIndex: "payment_date",
      key: "payment_date",
    },
    {
      title: "Ref.Number",
      dataIndex: "reference_number",
      key: "reference_number",
    },
    {
      title: "Actions",
      key: "Actions",
      render: (text, record, { _id }) => (
        <Tooltip title='Edit'>
          {/* <Button
            type="primary"
            size="small"
            onClick={() => showModal(record.id)}
          > */}
          <EditOutlined onClick={() => showModal(record.id)} />
          {/* </Button> */}
        </Tooltip>
      ),
    },
  ];

  const showModal = async (id) => {
    const { success, data } = await transactionService.viewTransaction(id);
    if (success) {
      setSelectedRecord(data.ledger.id);
      setBanks(data.banks);
      setPaymentMode(data.payment_modes);
      form.setFieldsValue({
        ...data.ledger,
        payment_date: data.ledger.payment_date
          ? dayjs(data.ledger.payment_date)
          : null,
        bank: data.ledger.bank_id,
        payment_mode: data.ledger.payment_mode_id,
      });
    }
    setIsModalShow(true);
  };

  const handleOk = () => {
    setIsModalShow(false);
  };

  const handleCancel = () => {
    setIsModalShow(false);
  };

  const onFinish = async (values) => {
    setLoading(true);
    const data = {
      ...values,
      payment_date: values.payment_date.format("YYYY-MM-DD"),
    };

    const response = await transactionService.editTransaction(
      selectedRecord,
      data
    );
    if (response.success) {
      notification.success({
        message: "Updated Successfully!",
        description: response.message,
        placement: "topRight",
      });
      initialize(pagination.current, pagination.pageSize)
    } else {
      notification.error({
        message: "Error updating",
        description: response.message,
        placement: "topRight",
      });
    }
    setLoading(false);
    setIsModalShow(false);
  };

  const initialize = async (page = 1, pageSize = pagination.current) => {
    setLoading(true);
    const { success, data } = await transactionService.fetch(page, pageSize);
    if (success) {
      setTransactions(data.data);
      setPagination((prev) => ({
        ...prev,
        total: data.total,
        current: page,
        pageSize,
      }));
    }
    setLoading(false);
  };

  useEffect(() => {
    changeDocumentTitle('Browse Transactions')
    initialize(pagination.current, pagination.pageSize);
  }, []);


  return (
    <div
      style={{
        padding: "5px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
      }}
    >
      <Row gutter={16} style={{ paddingTop: "5px" }}>
        <Col span={12}>
          <h1 style={{ fontWeight: "bold" }} className="pl-2 pt-3">
            Browse Transactions
          </h1>
        </Col>
      </Row>

      {/* Edit Modal */}
      <Modal
        title={<div style={{ width: "100%" }}>Edit Invoice</div>}
        open={isModalShow}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        closable={true}
        width={700}
        style={{ padding: "15px" }}
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
          requiredMark={false}
        >
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                label="Invoice Number"
                name="invoice_id"
                rules={[
                  {
                    required: true,
                    message: "Please enter the number of allowed appointments",
                  },
                ]}
              >
                <Input type="number" placeholder="Enter number" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Ref. Number"
                name="reference_number"
                rules={[
                  { required: true, message: "Please enter the start time" },
                ]}
              >
                <Input placeholder="Enter start time" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Date"
                name="payment_date"
                rules={[{ required: true, message: "Please select a date" }]}
              >
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="Invoice Amount"
                name="invoice_amount"
                rules={[
                  { required: true, message: "Please enter the start time" },
                ]}
              >
                <Input placeholder="Enter start time" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Transaction Amount"
                name="amount"
                rules={[
                  { required: true, message: "Please enter the end time" },
                ]}
              >
                <Input placeholder="Enter end time" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Balance"
                name="balance"
                rules={[
                  { required: true, message: "Please enter the end time" },
                ]}
              >
                <Input placeholder="Enter end time" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Mode Of Payment"
                name="payment_mode"
                rules={[
                  {
                    required: true,
                    message: "Please select an appointment type",
                  },
                ]}
              >
                <Select placeholder="Select type">
                  {paymentMode.map((payment) => (
                    <Select.Option key={payment.id} value={payment.id}>
                      {payment.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Bank"
                name="bank"
                rules={[
                  {
                    required: true,
                    message: "Please select an appointment type",
                  },
                ]}
              >
                <Select placeholder="Select type">
                  {banks.map((bank) => (
                    <Select.Option key={bank.id} value={bank.id}>
                      {bank.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Payment Status"
                name="status"
                rules={[
                  {
                    required: true,
                    message: "Please select an appointment type",
                  },
                ]}
              >
                <Select placeholder="Select type">
                  <Select.Option value={0}>Not Paid</Select.Option>
                  <Select.Option value={1}>Partial</Select.Option>
                  <Select.Option value={2}>Complete</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            {/* </Row> */}
            <Col span={24}>
              <Form.Item>
                <div style={{ textAlign: "center", marginTop: "12px" }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ width: "60%" }}
                    loading={loading}
                  // onClick={handleOk}
                  >
                    Update
                  </Button>
                </div>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>

      <Table
        columns={columns}
        scroll={{ x: "max-content" }}
        dataSource={transactions}
        style={{ marginTop: "10px" }}
        rowKey="id"
        loading={loading}
        pagination={false}
        footer={() => (
          <div className="flex justify-between items-center text-xs ">
            <div className=" text-gray-600">
              Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
              {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
              {pagination.total} entries
            </div>
            <Pagination
              current={pagination.current}
              total={pagination.total}
              pageSize={pagination.pageSize}
              showSizeChanger={false}
              onChange={(page) => initialize(page, pagination.pageSize)}
              itemRender={(current, type, originalElement) => {
                if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                return originalElement;
              }}
            />
          </div>
        )}
      />
    </div>
  );
}
export default BrowseTranscation;
